module.exports = __webpack_public_path__ + "static/media/hu.3cb3299d.svg";